<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        document.documentElement.classList.add('js-enabled');
        window.foucTimeout = setTimeout(function() {
            document.documentElement.classList.remove('js-enabled');
        }, 2000);
    </script>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#F8F9FA">
    <link rel="preload" as="font" href="fonts/Lato-Regular.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Lato-Bold.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Fredoka-SemiBold.woff2" type="font/woff2" crossorigin>
    <title>Book a Tour | Little Explorers Nursery</title>
    <link rel="icon" type="image/svg+xml" href="images/logo.svg">
    <meta name="description" content="Book a personal tour of Little Explorers Nursery in Anytown.">
    <!-- 2026 AI Agent Discovery Links -->
    <link rel="alternate" type="text/plain" title="LLM Summary (Low Token)" href="/llms.txt">
    <link rel="alternate" type="text/plain" title="LLM Full Knowledge Base (High Token)" href="/llms-full.txt">
    <!-- Open Graph / Social Media -->
    <meta property="og:type" content="website">
    <meta property="og:url" content="https://littleexplorersnursery.example.com/contact">
    <meta property="og:title" content="Book a Nursery Tour | Little Explorers Nursery Anytown">
    <meta property="og:description" content="Conveniently located in Anytown (AT1), our nursery welcomes new families. Book a personal tour to explore our spaces, meet the team, and discuss your childcare needs.">
    <meta property="og:image" content="https://littleexplorersnursery.example.com/images/og-image.jpg">
    <meta name="twitter:card" content="summary_large_image">
    <link rel="stylesheet" href="css/style.css">
    <script type="module" src="js/lib/dotlottie/dotlottie-player.mjs"></script>
    
    <!-- 2026 Speculation Rules for Instant Navigation -->
    <script type="speculationrules">
    {
      "prerender": [{
        "source": "document",
        "where": {"href_matches": "/*"},
        "eagerness": "moderate"
      }]
    }
    </script>
    <script defer src="/vendor/gsap.min.js"></script>
    <script defer src="/vendor/ScrollTrigger.min.js"></script>
    <script type="module" src="/js/main.js"></script>
    <script type="module" src="/js/global-animations.js"></script>
    <script type="module" src="/js/contact.js"></script>
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "ReserveAction",
      "name": "Book a Nursery Tour",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://littleexplorersnursery.example.com/contact",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "provider": {
        "@type": "ChildCare",
        "name": "Little Explorers Nursery",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Anycity",
          "postalCode": "AT1 5LB"
        }
      }
    }
    </script>
</head>
<body>

    <!-- MOBILE NAVBAR START -->
    <nav class="mobile-navbar" aria-label="Mobile top bar">
        <a href="/" class="mobile-logo-link">
            <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="mobile-logo" width="45" height="44" loading="eager" fetchpriority="high">
        </a>
        <button type="button" class="mobile-menu-toggle" aria-label="Toggle navigation" aria-expanded="false">
            <span class="bar"></span>
            <span class="bar"></span>
        </button>
    </nav>

    <!-- MOBILE CURTAIN OVERLAY NAVIGATION -->
    <div class="mobile-menu-overlay" aria-hidden="true" style="display: none;">
        <nav class="mobile-overlay-nav">
            <ul class="mobile-overlay-list">
                <li><a href="/" class="mobile-overlay-link">Home</a></li>
                <li><a href="rooms" class="mobile-overlay-link">Our Rooms</a></li>
                <li><a href="staff" class="mobile-overlay-link">Our Team</a></li>
                <li><a href="fees" class="mobile-overlay-link">Fees & Info</a></li>
                <li><a href="contact" class="mobile-overlay-link cta-pill">Book a Tour</a></li>
            </ul>
        </nav>
    </div>
    <!-- MOBILE NAVBAR END -->

    <!-- DESKTOP NAVBAR START -->
    <header class="site-header">
        <div class="container header-inner">
            <a href="/" class="logo-link">
                <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="site-logo" width="61" height="60" loading="eager" fetchpriority="high">
            </a>
            <nav class="nav-links">
                <a href="/">Home</a>
                <a href="rooms">Our Rooms</a>
                <a href="staff">Our Team</a>
                <a href="fees">Fees & Info</a>
            </nav>
            <div class="header-cta">
                <a href="contact" class="btn btn-primary">Book a Tour</a>
            </div>
        </div>
    </header>
    <!-- DESKTOP NAVBAR END -->

    <main>
        <!-- BOOKING STEPPER SECTION START -->
        <section class="booking-section section-padding">
            <div class="container">
                
                <div class="section-header text-center" style="margin-bottom: 2rem;">
                    <h1>Let's plan your 
                        <span class="crayon-wrap">
                            visit
                            <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h1>
                    <p>We can't wait to welcome you and your little one.</p>
                </div>

                <!-- ABC PYRAMID PROGRESS ANIMATION -->
                <div class="pyramid-container">
                    <!-- Changed to mask-icons to inherit the brand blue -->
                    <div class="abc-block block-a mask-icon" style="-webkit-mask-image: url('images/svgs/A.svg'); mask-image: url('images/svgs/A.svg'); color: var(--color-primary);"></div>
                    <div class="abc-block block-b mask-icon" style="-webkit-mask-image: url('images/svgs/B.svg'); mask-image: url('images/svgs/B.svg'); color: var(--color-primary);"></div>
                    <div class="abc-block block-c mask-icon" style="-webkit-mask-image: url('images/svgs/C.svg'); mask-image: url('images/svgs/C.svg'); color: var(--color-primary);"></div>
                </div>

                <!-- FORM WINDOW -->
                <div class="stepper-window">
                    
                    <!-- Form Content Track -->
                    <div id="form-content-track">
                        <form id="booking-form" toolname="bookNurseryTour" tooldescription="Book a personal guided tour of Little Explorers Nursery. Fills in the parent and child details, preferred care type, and tour date." toolautosubmit="true" novalidate>
                            <div class="stepper-track" id="stepper-track">
                                
                                <!-- STEP 1: Details -->
                                <div class="step-slide">
                                    <div class="step-header">
                                        <h2>A. You & Your Little One</h2>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="parent-name">Parent / Guardian Full Name</label>
                                            <input type="text" id="parent-name" name="parent-name" autocomplete="name" class="form-input" placeholder="e.g. Jane Doe…" required toolparamdescription="The full name of the parent or guardian booking the tour.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="child-name">Child's Name</label>
                                            <input type="text" id="child-name" name="child-name" class="form-input" placeholder="Leave blank if expecting…" toolparamdescription="The name of the child. Can be left blank if the child is not born yet.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="child-dob">Child's Date of Birth / Due Date</label>
                                            <input type="date" id="child-dob" name="child-dob" autocomplete="bday" class="form-input" required toolparamdescription="The child's date of birth, or the expected due date if expecting.">
                                        </div>
                                    </div>
                                    <div class="stepper-actions" style="justify-content: flex-end;">
                                        <button type="button" id="btn-next-1" class="btn btn-primary">Next Step</button>
                                    </div>
                                </div>

                                <!-- STEP 2: Needs -->
                                <div class="step-slide">
                                    <div class="step-header">
                                        <h2>B. Your Childcare Needs</h2>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="start-date">Desired Start Date</label>
                                            <input type="month" id="start-date" name="start-date" class="form-input" required toolparamdescription="The desired month and year when childcare should begin.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <fieldset class="form-group" style="border: none; padding: 0; margin: 0;">
                                            <legend class="form-label">Care Type</legend>
                                            <div class="radio-pill-group">
                                                <div class="radio-pill">
                                                    <input type="radio" id="care-allyear" name="care-type" value="All Year" checked toolparamdescription="Select for 51-week all-year-round childcare.">
                                                    <label class="radio-pill-label" for="care-allyear">All Year Round</label>
                                                </div>
                                                <div class="radio-pill">
                                                    <input type="radio" id="care-term" name="care-type" value="Term Time Only" toolparamdescription="Select for term-time only childcare.">
                                                    <label class="radio-pill-label" for="care-term">Term Time Only</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="child-info">Tell us a little bit about your child</label>
                                            <textarea id="child-info" name="child-info" class="form-textarea" placeholder="Any favourite activities, routines, or things we should know?" toolparamdescription="Additional background information about the child, such as favourite activities or routines."></textarea>
                                        </div>
                                    </div>
                                    <div class="stepper-actions">
                                        <button type="button" id="btn-back-1" class="btn btn-back">← Back</button>
                                        <button type="button" id="btn-next-2" class="btn btn-primary">Next Step</button>
                                    </div>
                                </div>

                                <!-- STEP 3: Contact & Submit -->
                                <div class="step-slide">
                                    <div class="step-header">
                                        <h2>C. Lock in your Tour</h2>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="email">Email Address</label>
                                            <input type="email" id="email" inputmode="email" spellcheck="false" name="email" autocomplete="email" class="form-input" placeholder="jane@example.com…" required toolparamdescription="The email address to confirm the tour booking.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="phone">Phone Number</label>
                                            <input type="tel" id="phone" inputmode="tel" name="phone" autocomplete="tel" class="form-input" placeholder="07123 456789…" required toolparamdescription="The best phone number to reach the parent.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label class="form-label" for="tour-date">Preferred Tour Date</label>
                                            <input type="date" id="tour-date" name="tour-date" class="form-input" required toolparamdescription="The specific date requested for the nursery tour.">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <fieldset class="form-group" style="border: none; padding: 0; margin: 0;">
                                            <legend class="form-label">Time Slot</legend>
                                            <div class="radio-pill-group">
                                                <div class="radio-pill">
                                                    <input type="radio" id="time-1030" name="time-slot" value="10:30 AM" checked toolparamdescription="10:30 AM tour slot.">
                                                    <label class="radio-pill-label" for="time-1030">10:30 AM</label>
                                                </div>
                                                <div class="radio-pill">
                                                    <input type="radio" id="time-1130" name="time-slot" value="11:30 AM" toolparamdescription="11:30 AM tour slot.">
                                                    <label class="radio-pill-label" for="time-1130">11:30 AM</label>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div class="form-row" style="margin-top: 2rem;">
                                        <div class="form-group checkbox-group">
                                            <label class="checkbox-label" for="gdpr-consent">
                                                <!-- Hidden native checkbox for accessibility & JS validation -->
                                                <input type="checkbox" id="gdpr-consent" name="gdpr-consent" class="visually-hidden form-input-checkbox" required toolparamdescription="User consent to store details according to the Privacy Policy.">
                                                
                                                <!-- Custom UI Checkbox -->
                                                <span class="custom-checkbox" aria-hidden="true">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="check-icon">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                
                                                <!-- Label Text -->
                                                <span class="checkbox-text">
                                                    I consent to my details being stored to arrange this tour, in accordance with the <a href="privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="stepper-actions">
                                        <button type="button" id="btn-back-2" class="btn btn-back">← Back</button>
                                        <button type="submit" id="btn-submit" class="btn btn-primary btn-large">Confirm Tour</button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>

                    <!-- SUCCESS STATE HIDDEN -->
                    <div id="success-state" class="success-state">
                        <div class="complete-lottie-wrap">
                            <!-- Removed 'autoplay' and added an ID so we can control the freeze -->
                            <dotlottie-player id="success-lottie" src="images/animations/complete.lottie"></dotlottie-player>
                        </div>
                        <h3>Yay! We've got your details.</h3>
                        <p>little explorers nursery will be in touch shortly to confirm your personal tour.</p>
                    </div>

                </div>
            </div>
        </section>
        <!-- BOOKING STEPPER SECTION END -->

        <!-- MAP & CONTACT INFO SECTION -->
        <section class="contact-bottom section-padding">
            <div class="container">
                <div class="contact-grid">
                    <div class="contact-details">
                        <h2>
                            <span class="crayon-wrap">
                                Find us
                                <svg class="crayon-svg highlight" viewBox="0 0 140 40" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 20,20 C 50,17 90,23 120,20" fill="none" stroke="#F6CD99" stroke-width="22" stroke-linecap="round"></path>
                            </svg>
                            </span>
                            in Anytown.
                        </h2>
                        <p>
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/map.svg'); mask-image: url('images/icons/map.svg'); width: 24px; height: 24px; min-width: 24px; color: var(--color-primary);"></span>
                            <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a>
                        </p>
                        <p>
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/phone.svg'); mask-image: url('images/icons/phone.svg'); width: 24px; height: 24px; min-width: 24px; color: var(--color-primary);"></span>
                            <a href="tel:+442079460123">020 7946 0123</a>
                        </p>
                        <p>
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/email.svg'); mask-image: url('images/icons/email.svg'); width: 24px; height: 24px; min-width: 24px; color: var(--color-primary);"></span>
                            <a href="mailto:hello@littleexplorersnursery.example.com">hello@littleexplorersnursery.example.com</a>
                        </p>
                    </div>
                    <div class="map-card">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d158858.4734006246!2d-0.2416815456247345!3d51.52855824166248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon!5e0!3m2!1sen!2suk!4v1710000000000!5m2!1sen!2suk" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        </section>

        <!-- FOOTER START -->
        <footer class="site-footer">
            <div class="container">
                <div class="footer-grid">
                    <div class="footer-col brand-col">
                        <h3 class="footer-logo-text"><span translate="no">Little Explorers Nursery</span></h3>
                        <p>A nurturing, home-from-home early years setting in the heart of Anytown, Anycity.</p>
                        <div class="footer-badges">
                            <a href="https://ratings.food.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="images/svgs/fhrs-badge-5.svg" alt="Food Hygiene Rating 5" class="footer-badge-img" width="160" height="80">
                            </a>
                            <a href="https://reports.ofsted.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Read our Ofsted Report">
                                <img loading="lazy" src="images/svgs/Ofsted_Good_GP_White.svg" alt="Ofsted Good Provider" class="ofsted-footer-badge" width="60" height="60">
                            </a>
                        </div>
                    </div>
                    <div class="footer-col links-col">
                        <h4>Explore</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="rooms">Our Rooms</a></li>
                            <li><a href="staff">Our Team</a></li>
                            <li><a href="fees">Fees & Funding</a></li>
                            <li><a href="contact">Contact</a></li>
                        </ul>
                    </div>
                    <div class="footer-col contact-col">
                        <h4>Get in Touch</h4>
                        <address>
                            <ul>
                                <li><strong>A:</strong> <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a></li>
                                <li><strong>T:</strong> <a href="tel:+442079460123">020 7946 0123</a></li> 
                                <li><strong>E:</strong> <a href="mailto:hello@littleexplorersnursery.example.com">hello@littleexplorersnursery.example.com</a></li>
                            </ul>
                        </address>
                        <h4 class="hours-title">Opening Hours</h4>
                        <p class="hours-text"><span>Mon - Fri: 8:00am - 6:00pm</span><span>Sat - Sun: Closed</span></p>
                    </div>
                </div>
                <div class="footer-bottom">
                    <p>&copy; <span id="current-year"></span> All Rights Reserved - <a href="https://selcreative.co.uk/" target="_blank" rel="noopener noreferrer">SEL Creative</a></p>
                    <div class="legal-links">
                        <a href="privacy">Privacy Policy</a>
                        <span class="divider">|</span>
                        <a href="safeguarding">Safeguarding Policy</a>
                    </div>
                </div>
            </div>
        </footer>
        <!-- FOOTER END -->
    </main>

</body>
</html>
